<template>
    <span ref="numberCountUp">0</span>
</template>

<script>
// this is a wrapper around the plugin
import CountUpInstance from '@plugins/countUp';

/**
 * Number count component that only displays a number which can be to in-line text elements
 */
export default {
    name: 'CountUpItemNumber',
    props: {
        /**
         *  When this property turns to true, the component will start counting
         */
        shouldStart: {
            type: Boolean,
            required: true,
            default: false,
        },
        /**
         *  The number where the count should stop (required)
         */
        end: {
            type: Number,
            required: true,
            validator(value) {
                return value >= 0;
            },
        },
        /**
         *  The delay in milliseconds until the count starts (optional)
         */
        delay: {
            type: Number,
            required: false,
            validator(value) {
                return value >= 0;
            },
            default: 0,
        },

        /**
         * The options available for the counting. More info at: https://github.com/inorganik/countUp.js/#usage
         */
        options: {
            type: Object,
            default: () => ({}),
        },
    },
    data() {
        return {
            countUp: new CountUpInstance(),
            defaultOptions: {
                startVal: 0,
                useEasing: true,
                useGrouping: true,
                separator: ',',
                decimal: '.',
                prefix: '',
                suffix: '',
            },
        };
    },
    watch: {
        shouldStart(newValue) {
            if (newValue) {
                this.start();
            }
        },
    },
    mounted() {
        if (this.shouldStart) {
            this.start();
        }
    },
    methods: {
        start() {
            this.countUp.init(this.$refs.numberCountUp, this.end, {
                ...this.defaultOptions,
                ...this.options,
            });
            if (this.delay > 0) {
                setTimeout(() => this.startCount(), this.delay);
            } else {
                this.startCount();
            }
        },
        startCount() {
            this.countUp.start();
        },
    },
};
</script>
